export const STREAM = "Stream";
export const GROUP = "Group";
export const COLLECTION = "Collection";
export const REPORTS = "Reports";
export const ADD_PAGE = "Add Page";
export const ASSET_DETAIL = "Asset Detail";
export const CLONE_ASSET = "Clone Asset";
export const CONVERSATION = "Conversation";
export const CONTENT_MAP = "Content Map";
export const REPORT = "Report";
export const CREATE_ASSET = "Create Asset";
export const ASSET = "Asset";
export const SEEK = "Seek";
export const CONTENT_HUB = "Content Hub";
export const SEARCH = "Search";
export const COMPOSE = "Compose";
export const COLLECTION_DETAIL = "Collection Detail";

export enum Medium {
  LINKEDIN = "Linkedin"
}

export const CONTENT_AGING = "Content Aging";
export const UNSTRUCTURED_CONTENT = "Unstructured Content";
export const CONTENT_DUPLICATION = "Content Duplication";
export const CONTENT_EXPIRY = "Content Expiry";
